import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import Backend from 'i18next-http-backend';
import {Cookies} from 'react-cookie';

const getLanguage = () => {
    if (i18n.language && i18n.language.length > 0) return i18n.language;

    const langSelectionCookieKey = 'mv-lang-selection';
    const defaultLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE;
    const cookies = new Cookies();
    const currentUrl = window.location.search;
    const urlParams = new URLSearchParams(currentUrl);
    const langQuery = urlParams.get('lang');
    const supportedLanguages = process.env.REACT_APP_SUPPORTED_LANGUAGES;
    const supportedLanguagesList = supportedLanguages?.split(',');

    let lang = defaultLanguage;
    lang = cookies.get(langSelectionCookieKey) ?? lang;
    if (langQuery !== null && supportedLanguagesList?.includes(langQuery)) {
        lang = langQuery;
    }
    return lang;
};

i18n.use(Backend)
    .use(initReactI18next)
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        lng: getLanguage(),
        // fallbackLng: ['sv', 'en'],
        fallbackLng: ['sv'],
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false
        },
        backend: {
            queryStringParams: {v: '3.3'} // version of your app this will bypass cache when you change version
        }
    });

export {i18n, getLanguage};
